import type { Epic, Metadata, ProductGoal, StatusFieldKey, TreeNode, ViewMode } from '@mona-roadmap/domain';
import { createContext, useContext } from 'react';
import type { Mutations, RevealRequest } from '../lib/mutations';

export interface RoadmapContextValue {
  metadata: Metadata;
  view: ViewMode;
  filtersActive: boolean;
  sprintColors: Record<string, { bg: string; fg: string }>;
  optionColor: (field: StatusFieldKey, label: string | null) => string | undefined;
  goalsById: Map<string, ProductGoal>;
  epicsById: Map<string, Epic>;
  mutations: Mutations;
  /** Open the detail drawer / editor for a node. */
  openNode: (node: TreeNode) => void;
  /** Quick filter: show only this goal / epic (calling it again on the same item clears it). */
  quickFilter: (node: TreeNode) => void;
  /** True when the node is the only goal / epic currently filtered to. */
  isQuickFiltered: (node: TreeNode) => boolean;
  /** Open the "New Deliverable" dialog pre-filled from a node's context. */
  addDeliverableTo: (node: TreeNode) => void;
  /** Expand to, flash (and optionally focus) a row, e.g. after a deliverable was moved. */
  reveal: (r: RevealRequest) => void;
}

const Ctx = createContext<RoadmapContextValue | null>(null);
export const RoadmapProvider = Ctx.Provider;

export function useRoadmapContext(): RoadmapContextValue {
  const v = useContext(Ctx);
  if (!v) throw new Error('RoadmapProvider missing');
  return v;
}
